import AdminNeedsOptInModal from 'admin/components/AdminNeedsOptInModal.jsx';
import AdminNeedsEmailConfModal from 'admin/components/AdminNeedsEmailConfModal.jsx';
import AdminRejectedModal from 'admin/components/AdminRejectedModal.jsx';
import AdminVerifiedModal from 'admin/components/AdminVerifiedModal.jsx';
import CurrentUser from 'auth/CurrentUser';
import linkStateWithStores from 'components/mixins/linkStateWithStores';
import AffiliationStore from 'stores/AffiliationStore';
import { hasPendingRole, needsOptIn, needsEmailConf } from 'shapes/Affiliation';
import OrganizationStore from 'stores/OrganizationStore';
import PromptActions from 'actions/PromptActions';
import { PromptNames } from 'constants/PromptConstants';
import PromptStore from 'stores/PromptStore';
import Prompt from 'entities/Prompt';
import React from 'react';
import { mountModal } from 'lib/modal';

const AdminVerificationModals = React.createClass({
  propTypes: {
    location: React.PropTypes.object.isRequired,
  },

  mixins: [
    linkStateWithStores([PromptStore, AffiliationStore]),
  ],

  getInitialState() {
    // XXX this should be handled by real state
    this.hasShownAny = false;
    return this.getStateFromStores();
  },

  componentDidMount() {
    this.checkForPrompts();
  },

  componentDidUpdate() {
    this.checkForPrompts();
  },

  onRequestHide(prompt) {
    // Check that this is a Prompt rather than an event
    if (prompt instanceof Prompt) {
      PromptActions.recordDismissExistingPrompt(prompt);
    }
  },

  getStateFromStores() {
    return {
      verifiedModalPrompt: PromptStore.getAvailable(PromptNames.ADMIN_VERIFIED_MODAL),
      rejectedModalPrompt: PromptStore.getAvailable(PromptNames.ADMIN_REJECTED_MODAL),
      recentlyDismissedPreverified:
        PromptStore.hasDismissedWithin(PromptNames.ADMIN_PREVERIFIED_MODAL, 7),
      affiliations: AffiliationStore.getAffiliations(),
    };
  },

  checkForPrompts() {
    const query = this.props.location.query;
    const path = this.props.location.pathname;
    const hasAdminConsole = CurrentUser.getUser().hasFeature('web_admin_console');
    if (hasAdminConsole || query.admin || !path.includes('/classes')) {
      // Don't show if they just came through AFO or aren't on the classes page, or have the admin console
      return;
    }

    const { affiliations, verifiedModalPrompt, rejectedModalPrompt, recentlyDismissedPreverified } = this.state;

    if (!this.hasShownAny) {
      if (verifiedModalPrompt) {
        const orgId = verifiedModalPrompt.getMessageId();
        mountModal(
          <AdminVerifiedModal
            orgId={orgId}
            onRequestHide={this.onRequestHide.bind(this, verifiedModalPrompt)}
          />,
          this
        );
        this.hasShownAny = true;
      } else if (rejectedModalPrompt) {
        const orgId = rejectedModalPrompt.getMessageId();
        mountModal(
          <AdminRejectedModal
            orgId={orgId}
            onRequestHide={this.onRequestHide.bind(this, rejectedModalPrompt)}
          />,
          this
        );
        this.hasShownAny = true;
      } else if (affiliations && affiliations.length) {
        const affWithPendingRole = affiliations.find(hasPendingRole);
        if (affWithPendingRole) {
          if (needsOptIn(affWithPendingRole) && !recentlyDismissedPreverified) {
            const org = OrganizationStore.getOrganization(affWithPendingRole.organization_id);
            const prompt = PromptStore.getPrompt(PromptNames.ADMIN_PREVERIFIED_MODAL);
            if (!prompt || prompt.isLessThanDaysOld(30)) {
              mountModal(
                <AdminNeedsOptInModal
                  affiliation={affWithPendingRole}
                  orgName={org.getName()}
                  onRequestHide={this.onRequestHide}
                />,
              this
              );
              this.hasShownAny = true;
            }
          } else if (needsEmailConf(affWithPendingRole)) {
            const org = OrganizationStore.getOrganization(affWithPendingRole.organization_id);
            mountModal(
              <AdminNeedsEmailConfModal
                affiliation={affWithPendingRole}
                orgName={org.getName()}
                onRequestHide={this.onRequestHide}
              />,
            this
            );
            this.hasShownAny = true;
          }
        }
      }
    }
  },

  render() {
    return null;
  },
});

export default AdminVerificationModals;



// WEBPACK FOOTER //
// ./src/admin/components/AdminVerificationModals.jsx